var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Select2Multiple',{staticClass:"multi-select w-100-select",attrs:{"settings":{ multiple: _vm.multiple, placeholder: _vm.placeholder },"value":_vm.value,"options":_vm.employeeOptions},on:{"change":_vm.handleChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }